import { Collapse } from 'antd';
import type { ComplianceDocumentEntry } from '../lib/compliance-documents';

interface ComplianceDocumentHistoryProps {
  entries: ComplianceDocumentEntry[];
  onOpen: (documentId: string) => void;
}

/** A document type's superseded documents — everything but the current one, oldest disclosed on demand (gitaumoses4/chukua#17). Renders nothing once there's no history. */
export function ComplianceDocumentHistory({ entries, onOpen }: ComplianceDocumentHistoryProps) {
  if (entries.length === 0) return null;

  return (
    <Collapse
      ghost
      size="small"
      items={[
        {
          key: 'history',
          label: `History (${entries.length})`,
          children: (
            <ul className="flex flex-col gap-2">
              {entries.map((entry) => (
                <li key={entry.id} className="flex items-center justify-between gap-3 text-sm">
                  <button type="button" className="text-link hover:underline" onClick={() => onOpen(entry.id)}>
                    {entry.number}
                  </button>
                  <span className="text-muted">Expired {new Date(entry.expiryDate).toLocaleDateString()}</span>
                </li>
              ))}
            </ul>
          ),
        },
      ]}
    />
  );
}
